module.exports = __webpack_public_path__ + "img/Sul.7be8c8ae.svg";